import { MdErrorOutline } from 'react-icons/md';

/**
 * Error state when search fails.
 */
export default function ResultsListError({ message, onRetry }) {
  return (
    <div
      className="flex flex-col items-center justify-center py-12 px-6 min-h-[240px] rounded-2xl border border-red-200 dark:border-red-900/50 bg-red-50/50 dark:bg-red-900/10"
      role="alert"
    >
      <MdErrorOutline className="text-4xl text-red-500 dark:text-red-400 mb-3" aria-hidden />
      <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-1 text-center">
        Greška pri učitavanju
      </h3>
      <p className="text-sm text-gray-600 dark:text-gray-400 text-center max-w-sm mb-4">
        {message || 'Nismo mogli da učitamo rezultate. Pokušajte ponovo.'}
      </p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="px-4 py-2 rounded-xl bg-primary-600 text-white font-medium hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        >
          Pokušaj ponovo
        </button>
      )}
    </div>
  );
}
